export function fetchVisualizations(context, parameters) {
  context.commit("setFetchingState");

  context.rootState.client.getVisualization(
    "",
    parameters,
    function (err, _, data) {
      if (err) {
        context.commit("setRequestError", err);
        return;
      }
      context.commit("setVisualizations", data);
      context.commit("setPagination", context.state.page);
      for (const visID in context.state.list) {
        const visData = context.state.list[visID];
        visData.visible = true
        context.rootState.client.getMapLayers(
          visData.map_id,
          function (err, _, resp) {
            if (err) {
              context.commit("setRequestError", err);
              return;
            }
            const { layers } = resp
            //对layers倒序排列
            layers.sort((a, b) => {
              if (a.order < b.order) {
                return 1; 
              }
              if (a.order > b.order) {
                return -1;
              }
              return 0;
            })
            context.commit("setMapLaysers", { visID, layers });
          }
        );
      }
    }
  );
}

export function filter(context, { filter, keyword }) {
  context.commit("setPagination", 1);
  context.commit("setFilterType", filter);
  context.commit("setFilterKeyword", keyword);
  context.dispatch("fetch");
}

export function order(context, orderOptions) {
  context.commit("setPagination", 1);
  context.commit("setOrder", orderOptions);
  context.dispatch("fetch");
}

export function resetFilters(DEFAULT_VALUES) {
  return function (context) {
    context.commit("setPagination", 1);
    context.commit("setFilterType", "mine");
    context.commit("setResultsPerPage", 12);
    context.commit("setOrder", {
      order: DEFAULT_VALUES.order,
      direction: DEFAULT_VALUES.orderDirection,
    });
  };
}

export function setResultsPerPage(context, perPage) {
  context.commit("setResultsPerPage", perPage);
}
export function setPagination(context, page) {
  context.commit("setPagination", page);
}

export function setURLOptions(context, options) {
  context.commit("setPagination", parseInt(options.page || 1));
  context.commit("setFilterType", options.filter);
  context.commit("setOrder", {
    order: options.order,
    direction: options.order_direction,
  });
  context.commit("setResultsPerPage", options.per_page);
  context.commit("setQueryFilter", options.q);
  context.dispatch("fetch");
}


export function toggleMapLayserVisible(context, options) {
  context.commit("toggleMapLayserVisible", options);
}
export function toggleMapVisible(context, options) {
  context.commit("toggleMapVisible", options);
}

export function updateVisualization(context, visualizationOptions) {
  context.commit("maps/updateVisualization", visualizationOptions, {
    root: true,
  });
}

export function addToEarth({dispatch,commit,state}, visId) {
  commit("addToEarth",visId)
  const updateAttrs = {
        visualizationId: visId,
        visualizationAttributes: { added_to_map: true },
  };
  dispatch("updateVisualization", updateAttrs);
  const vis = state.addedList[visId]
  if (vis) {
    commit("maps/addToOrderList",vis,{root: true})
  }
}

export function removeFromEarth({dispatch,commit}, visId) {
  commit("removeFromEarth",visId)
  const updateAttrs = {
        visualizationId: visId,
        visualizationAttributes: { added_to_map: false },
  };
  dispatch("updateVisualization", updateAttrs);
  commit("maps/removeFromOrderList",visId,{root: true})
}

export function setOrderList(context, newList) {
  context.commit("setOrderList",newList)
}
export function removeVis(context, visData) {
  context.commit("removeVis",visData)
}